import axios from 'axios';
import { buildApiV2Url } from '../utils/apiUtils';
import { generateApiError } from '../utils/apiErrorMessages';
import { SURVEY_TYPE_COLLECTION_PATH } from '../config/EntityCollectionPathMap';

export default (entityId, isFavorite) =>
  axios
    .patch(buildApiV2Url(`${SURVEY_TYPE_COLLECTION_PATH}/${entityId}`), {
      is_favorite: isFavorite,
    })
    .catch(generateApiError());
